/*

# Dependencies
	- mod.js
	- mod.baseModule.js
	- jquery 1.7+

*/

!function($, mod, window, undefined) {

	var factory = {

		// A list of all the known Modules
		map: {},

		// The baseline object that child objects will extend
		base: function() {},

		// Define a new Module and register it with the factory
		define: function(name, extend, proto) {
			if (!this.map[name]) {
				var extendFn = this.map[extend] || this.base;
				var protoFn = proto || extend;

				// Create and extend the prototype
				var fn = function() {};
				this.extend(fn, extendFn);
				protoFn(fn);

				// Set some special properties
				fn.prototype.name = name;
				fn.prototype._parent = extendFn.prototype;
				fn.prototype.events = $.extend(true, {}, extendFn.prototype.events, fn.prototype.events);

				// Saved the combined function in the map
				this.map[name] = fn;

				// Leave a check in to find race conditions b/w base/child
				if (typeof extend == "string" && !this.map[extend]) {
					console.error('factory: parent class not found "' + name + ':' + extend + '"');
				}
			}
		},

		// Instantiate a known Module
		create: function(name, el, params) {
			var module = null;

			if (name in this.map) {
				var fn = this.map[name];
				module = new fn();

				if ($.isReady) {
					module._init(el, params || {});
				} else {
					$(function () {
						module._init(el, params || {});
					});
				}

			}
			else {
				console.warn('factory: no module named "' + name + '"');
			}

			return module;
		},

		extend: function(subClass, superClass) {
			var fn = function() {};
			fn.prototype = superClass.prototype;
			subClass.prototype = new fn();
			subClass.prototype.constructor = subClass;

			if (superClass.prototype.constructor == Object.prototype.constructor) {
				superClass.prototype.constructor = superClass;
			}
		}

	};

	mod.factory = {
		create: function(baseModule) {
			// Get a new factory
			var f = $.extend(true, {}, factory);

			// Set the base object
			if (baseModule) {
				f.extend(f.base, baseModule);
			}

			return f;
		}
	};

}(jQuery, window.mod, window);